import globalComputed from "./global-computed"
export default {
    auth: [
        {
            icon: 'mdi-home-outline',
            name: 'الصفحة الرئيسية',
            to: {name: 'home'}
        },
        {
            icon: 'mdi-account-circle-outline',
            name: 'الملف الشخصي',
            to: {name: 'profile'}
        },
        {
            icon: 'mdi-book-multiple-outline',
            name: 'دوراتي',
            to: {name: 'my-courses'}
        },
        {
            icon: 'mdi-play-box-multiple-outline',
            name: 'الدورات التعليمية',
            to: {name: 'courses'}
        },
        {
            icon: 'mdi-bookshelf',
            name: 'المذكرات',
            to: {name: 'attachments'}
        },
        {
            icon: 'mdi-office-building-marker-outline',
            name: 'منافذنا',
            to: {name: 'our-outlets'},
            show: 'webOnly'
        },
        {
            icon: 'mdi-account-tie-outline',
            name: 'المعلمين',
            to: {name: 'teachers'},
            show: 'showTeachers'
        },
        {
            icon: 'mdi-trophy-outline',
            name: 'لوحة الشرف',
            to: {name: 'honor-panel'},
            show: 'showHonorPanel'
        },
        {
            icon: 'mdi-clipboard-text-outline',
            name: 'الامتحان اﻹلكتروني',
            to: {name: 'exams'},
            show: 'showExams',
        },
        {
            icon: 'mdi-file-question-outline',
            name: 'أسئلتي',
            to: {name: 'my-questions'},
        },
        {
            icon: 'mdi-folder-multiple-outline',
            name: 'بنك الأسئلة',
            to: {name: 'questions-bank'},
        },
        {
            icon: 'mdi-license',
            name: 'نتائج واجباتي',
            to: {name: 'my-homeworks'},
        },
        {
            icon: 'mdi-license',
            name: 'نتائج امتحاناتي',
            to: {name: 'my-exams'},
        },
        {
            icon: 'mdi-clipboard-remove-outline',
            name: 'الأسئلة الخاطئة',
            to: {name: 'wrong-answers'},
            show: 'showWrongAnswers',
        },
        {icon:'mdi-file-document-multiple-outline',name:'تقاريري',to:{name:'my-reports'}},
        {icon:'mdi-brain', name:'تدريباتي', to:{name:'practice-exams'}},
        {
            icon: 'mdi-wallet-outline',
            name: 'المحفظة الإلكترونية',
            to: {name: 'wallet'},
            show: 'showWallet',
        },
        {
            icon: 'mdi-wallet-bifold-outline',
            name: 'مدفوعات السنتر',
            to: {name: 'center-wallet'},
            show: 'showCenterWallet',
        },
        {
            icon: 'mdi-information-outline',
            name: 'عن المنصة',
            to: {name: 'about'},
            divider: true,
        },
        {
            icon: 'mdi-text-box-outline',
            name: 'سياسة الخصوصية',
            to: '/privacy-policy'
        },
        {
            icon: 'mdi-format-list-bulleted',
            name: 'شروط الاستخدام',
            to: '/terms'
        },
        {
            icon: 'mdi-help-circle-outline',
            name: 'روابطنا الرسمية',
            to: {name: 'links'}
        },
        {
            icon: 'mdi-account-voice',
            name: 'الدعم النفسي',
            href: 'https://talk.magacademy.co/',
            target: '_system',
        },
        {
            icon: 'mdi-seal-variant',
            name: 'من سيربح المليون',
            href: 'https://millionaire.magacademy.co/',
            target: '_system',
        },
        {
            icon: 'mdi-help-circle-outline',
            name: 'الدعم الفني',
            to: {name: 'help'}
        }
    ],
    guest: [
        {
            icon: 'mdi-home-outline',
            name: 'الصفحة الرئيسية',
            to: {name: 'welcome'}
        },
        {
            icon: 'mdi-account-plus-outline',
            name: 'حساب جديد',
            to: {name: 'register'}
        },
        {
            icon: 'mdi-login-variant',
            name: 'تسجيل الدخول',
            to: {name: 'login'}
        },
        {
            icon: 'mdi-account-voice',
            name: 'الدعم النفسي',
            href: 'https://talk.magacademy.co/',
            target: '_system',
        },
        {
            icon: 'mdi-seal-variant',
            name: 'من سيربح المليون',
            href: 'https://millionaire.magacademy.co/',
            target: '_system',
        },
        {
            icon: 'mdi-information-outline',
            name: 'عن المنصة',
            to: {name: 'about'}
        },
        {
            icon: 'mdi-help-circle-outline',
            name: 'الدعم الفني',
            to: {name: 'help'}
        },
        {
            icon: 'mdi-text-box-outline',
            name: 'سياسة الخصوصية',
            to: '/privacy-policy'
        },
        {
            icon: 'mdi-format-list-bulleted',
            name: 'شروط الاستخدام',
            to: '/terms'
        },
    ]
}